export const templatesAviso = {
  mensajeLegal: `
  <div style="text-align: center;">
  <p>Somos Adecco Argentina una compañía con más de 30 años de experiencia que conecta empresas con talentos, brindando soluciones integrales de Recursos Humanos y buscamos talentos, ¡COMO VOS!&nbsp;</p>
  <p><br><i>Nuestro compromiso, es la #diversidad e #igualdad de oportunidades somos una empresa inclusiva. Cuando sos parte de nuestros procesos, solo cuentan tus méritos, logros y capacidades, lo hacemos pensando en vos como persona.</i>&nbsp;</p>
  <p><i>Participar de nuestros procesos de selección no tiene ningún costo para vos candidato/a, trabajar con vos es parte de nuestro compromiso y tarea con la comunidad. Postulate y participa en una oferta de empleo nuestra.</i>&nbsp;</p><p><i>El empleador sólo podrá solicitarle la información estrictamente necesaria para el desempeño en el trabajo que se ofrece.</i>&nbsp;</p>
  </div>
  `,

  encabezado: `
   <div style="text-align: center;">
  <p>BUSCAMOS TALENTOS,&nbsp;</p>
  <p>¡EN ADECCO TE ESTAMOS BUSCANDO!&nbsp;</p>
  </div>
  `,

  descripcionStaffing: `
  <p>Si te interesa ser <CARGO> y ser parte de Adecco prestando servicios en nuestro cliente IMPORTANTE EMPRESA DEL SECTOR <RUBRO>, ¡desafíate a vos mismo y crea tu futuro!</p> 
  `,
  descripcionPerm: `
  <p>Si te interesa ser <CARGO> en el equipo de nuestro cliente IMPORTANTE EMPRESA DEL SECTOR <RUBRO>, ¡desafíate a vos mismo y crea tu futuro!</p> 
  `,
};
